export const getInvoiceFilePayload = (list: string[]): { name: string, url: string }[] => {
  return list.map(url => {
    return { name: url.substring(url.lastIndexOf('/') + 1), url }
  })
}
